<!-- Page Content -->
<!-- Banner Starts Here -->
<!-- <div class="banner header-text">
      <div class="owl-banner owl-carousel">
        <div class="banner-item-01">
          <div class="text-content">
            <h4>Best Offer</h4>
            <h2>New Arrivals On Sale</h2>
          </div>
        </div>
        <div class="banner-item-02">
          <div class="text-content">
            <h4>Flash Deals</h4>
            <h2>Get your best products</h2>
          </div>
        </div>
        <div class="banner-item-03">
          <div class="text-content">
            <h4>Last Minute</h4>
            <h2>Grab last minute deals</h2>
          </div>
        </div>
      </div>
    </div> -->
<!-- Banner Ends Here -->

<!-- <ngb-carousel *ngIf="images" class="header-text">
      <ng-template ngbSlide>
        <div class="picsum-img-wrapper">
          <img [src]="images[0]" alt="Random first slide">
        </div>
        <div class="carousel-caption">
          <h4>Best Offer</h4>
            <h2>New Arrivals On Sale</h2>
          <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <div class="picsum-img-wrapper">
          <img [src]="images[1]" alt="Random second slide">
        </div>
        <div class="carousel-caption">
          <h4>Flash Deals</h4>
            <h2>Get your best products</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <div class="picsum-img-wrapper">
          <img [src]="images[2]" alt="Random third slide">
        </div>
        <div class="carousel-caption">
          <h4>Last Minute</h4>
            <h2>Grab last minute deals</h2>
          <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
        </div>
      </ng-template>
    </ngb-carousel> -->

<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
  <ol class="carousel-indicators">
    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
    <!-- <li data-target="#carouselExampleIndicators" data-slide-to="2"></li> -->
  </ol>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img class="d-block w-100 car-img" src="../../assets/images/H5.jpg" alt="First slide">
      <div class="carousel-caption d-none d-md-block">
      </div>
    </div>
    <div class="carousel-item">
      <img class="d-block w-100 car-img" src="../../assets/images/c2.jpg" alt="Second slide">
      <div class="carousel-caption d-none d-md-block">
      </div>
    </div>
    <div class="carousel-item">
      <img class="d-block w-100 car-img" src="../../assets/images/c1.jpg" alt="Third slide">
      <div class="carousel-caption d-none d-md-block">
      </div>
    </div>
    <div class="carousel-item">
      <img class="d-block w-100 car-img" src="../../assets/images/f.webp" alt="Fourth slide">
      <div class="carousel-caption d-none d-md-block">
      </div>
    </div>
   
  </div>
  <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>


<div class="latest-products">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="section-heading">
          <h2>Latest Products</h2>
          <a routerLink="/products">view all products <i class="fa fa-angle-right"></i></a>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 all des dev gra" *ngFor="let product of products">
        <div class="product-item" style="width: 300px; height: 400px;" (click)="setData(product)">
          <a><img class="border-bottom" src='{{product["420Path"][0] }}' width="200" height="275" alt=""></a>
          <div class="down-content">
            <div class="row">
              <div class="col-md-8">
                <p class="h5 m-0">{{product.productName}}</p>
              </div>
              <div class="col-md-4">
                <p class="h6" style="color: black; font-weight: bold;">$ {{product.price.toFixed(2)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

